<script lang="ts">
  import type { Post } from '$lib/api/types'
  import { settings, type View } from '$lib/app/settings.svelte'
  import { PostIframe, PostImage, PostLink } from '..'
  import { iframeType, type MediaType } from '../helpers'
  import PostEvent from './PostEvent.svelte'
  import PostPoll from './PostPoll.svelte'

  interface Props {
    view?: View
    post: Post
    type?: MediaType
    opened?: boolean | undefined
    blur?: boolean
    [key: string]: any
  }

  let {
    view = 'cozy',
    post,
    type = 'none',
    opened = undefined,
    blur = post.nsfw && settings.nsfwBlur,
    ...rest
  }: Props = $props()
</script>

<!--
  @component
  This component will show either
  - A media item (pictures, videos) (large form factor posts only)
  - Embed link/card.
-->
{#if type == 'image' && view == 'cozy'}
  <PostImage {post} {blur} {...rest} />
{:else if (type == 'iframe' || type == 'video') && view == 'cozy' && post.url}
  <PostIframe
    thumbnail={post.thumbnail_url}
    type={iframeType(post.url)}
    url={post.url}
    {opened}
    title={post.name}
    {...rest}
  />
{:else if type == 'poll' && post.poll && view == 'cozy'}
  <PostPoll post={{ ...post, poll: post.poll! }} />
{:else if type == 'event' && post.event && view == 'cozy'}
  <PostEvent post={{ ...post, event: post.event! }} />
{:else if type == 'embed' && post.url}
  <PostLink
    url={post.url}
    thumbnail_url={post.thumbnail_url}
    nsfw={post.nsfw}
    embed_title={post.embed_title}
    embed_body={post.embed_description}
    {view}
    {...rest}
  />
{/if}
